<template>

    <div class="row clearfix">
        <div class="col-md-6 column">
            <div class="form-group">
                <label for="selPeriodeFiscale" class="form-label">{{$t('general.periodeFiscale')}}</label>
                <select v-model="dossier.periodeFiscale" name="periodeFiscale" id="selPeriodeFiscale" class="form-control">
                    <option v-for="(pf, index) in listePeriodesFiscales" v-bind:key="index" v-bind:value="pf">
                        {{ pf }}
                    </option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
import BaremeApi from '@/services/BaremeRestApi';

export default {
  name: 'section-periode-fiscale',
  props: ['dossier'],
  data() {
    return {
      listePeriodesFiscales: [],
    };
  },
  methods: {
    async getListePeriodeAutorise() {
      this.listePeriodesFiscales = await new BaremeApi().getListePeriodeFiscaleFormulairePrelevement();
      this.dossier.periodeFiscale = Math.max(...this.listePeriodesFiscales);
    },
  },
  mounted() {
    this.getListePeriodeAutorise();
  },
};
</script>

<style scoped>

</style>
